package com.bulut.mecitogullari.core.i18n

val TrStrings = Strings(
    monthNames = listOf(
        "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
        "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık",
    ),
    monthNamesShort = listOf(
        "Oca", "Şub", "Mar", "Nis", "May", "Haz",
        "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara",
    ),
    categoryLabels = mapOf(
        "Daire Satışı" to "Daire Satışı",
        "Kira Geliri" to "Kira Geliri",
        "Devir (Açılış Bakiyesi)" to "Devir (Açılış Bakiyesi)",
        "Diğer Gelir" to "Diğer Gelir",
        "Malzeme" to "Malzeme",
        "İşçilik" to "İşçilik",
        "Taşeron" to "Taşeron",
        "Arsa / Tapu" to "Arsa / Tapu",
        "Vergi & Harç" to "Vergi & Harç",
        "Nakliye & Yakıt" to "Nakliye & Yakıt",
        "Ofis / Genel" to "Ofis / Genel",
        "Ev Gideri" to "Ev Gideri",
        "Diğer Gider" to "Diğer Gider",
    ),
    values = mapOf(
        "income" to "Gelir",
        "expense" to "Gider",
        "netProfit" to "Net Kâr",
        "total" to "Toplam",
        "date" to "Tarih",
        "description" to "Açıklama",
        "category" to "Kategori",
        "project" to "Proje",
        "amount" to "Tutar",
        "cancel" to "Vazgeç",
        "save" to "Kaydet",
        "add" to "Ekle",
        "delete" to "Sil",
        "back" to "Geri",
        "ok" to "Tamam",
        "savedCheck" to "Kaydedildi ✓",
        "phoneOptional" to "Telefon (opsiyonel)",
        "noteOptional" to "Not (opsiyonel)",
        "none" to "—",
        "loginTagline" to "İnşaat Yönetim Platformu",
        "loginHighlights" to "Aylık kasa  •  Proje giderleri  •  Daire satışları",
        "continueWithGoogle" to "Google ile devam et",
        "continueAsGuest" to "Misafir olarak devam et",
        "loginFooter" to "Verileriniz güvenle bulutta saklanır.\n" +
            "Misafir girişinde veriler bu cihazdaki oturuma bağlıdır; çıkış yaparsanız erişilemez.",
        "errorGoogleToken" to "Google oturum bilgisi alınamadı.",
        "errorSignInFailed" to "Giriş başarısız oldu.",
        "errorGuestFailed" to "Misafir girişi başarısız oldu.",
        "guestName" to "Misafir",
        "defaultUserName" to "Kullanıcı",
        "tabHome" to "Panel",
        "tabTransactions" to "İşlemler",
        "tabProjects" to "Projeler",
        "tabReports" to "Rapor",
        "tabProfile" to "Profil",
        "greeting" to "Merhaba",
        "cashSummaryTemplate" to "{month} kasa özeti",
        "netProfitTitle" to "Bu Ayın Net Kârı",
        "closingBalanceLabel" to "Kasa (Ay Sonu Devir)",
        "statCarryOver" to "Devreden",
        "statMonthIncome" to "Bu Ay Gelir",
        "statMonthExpense" to "Bu Ay Gider",
        "recentTransactions" to "Son İşlemler",
        "seeAll" to "Tümünü Gör",
        "dashboardEmpty" to "Bu ay henüz işlem yok.\n(+) düğmesiyle ilk gelir veya gideri ekleyin.",
        "addTransaction" to "İşlem ekle",
        "transactionsSearchHint" to "Açıklama veya kategori ara",
        "tabAll" to "Tümü",
        "noRecordsForMonth" to "{month} için kayıt bulunamadı.",
        "noSearchMatch" to "Aramanızla eşleşen işlem yok.",
        "shortcutDebtSubtitle" to "Tedarikçi & müşteri",
        "shortcutCraftsmenSubtitle" to "İş karşılığı takas",
        "excelMenu" to "Excel",
        "exportExcel" to "Excel'e Aktar (.xlsx)",
        "importExcel" to "Excel'den İçe Aktar",
        "importExcelToProject" to "Excel'den İçe Aktar (bu projeye)",
        "downloadMonthPdf" to "Ayı PDF olarak indir",
        "downloadPdf" to "PDF olarak indir",
        "previousMonth" to "Önceki ay",
        "nextMonth" to "Sonraki ay",
        "profileTitle" to "Profil",
        "statProjects" to "Proje",
        "statSoldUnits" to "Satılan Daire",
        "statMonthNet" to "Bu Ay Net",
        "companySection" to "Firma Bilgileri",
        "companyNameLabel" to "Firma Adı",
        "shortcutsSection" to "Kısayollar",
        "debtTracking" to "Borç Takibi",
        "debtTrackingSubtitle" to "Tedarikçi hesapları, alımlar ve ödemeler",
        "craftsmenTitle" to "Ustalar • İş Karşılığı",
        "craftsmenSubtitle" to "Daire karşılığı çalışan ustaların hesabı",
        "languageSection" to "Dil",
        "logout" to "Çıkış Yap",
        "projectsEmpty" to "Henüz proje yok.\n\"Yeni Proje\" ile ilk şantiyenizi ekleyin.",
        "newProject" to "Yeni Proje",
        "statSales" to "Satış",
        "statNetIncome" to "Net Gelir",
        "reportsTitle" to "Aylık Rapor",
        "expenseBreakdown" to "Gider Dağılımı",
        "incomeBreakdown" to "Gelir Dağılımı",
        "noExpenseThisMonth" to "Bu ay gider kaydı yok.",
        "noIncomeThisMonth" to "Bu ay gelir kaydı yok.",
        "cashNoteSection" to "Kasa Devir Notu",
        "cashNotePlaceholder" to "Ay sonu kasa teslimi ile ilgili notlar…",
        "saveNote" to "Notu Kaydet",
        "carryToNextMonth" to "Sonraki Aya Devir",
        "openingBalanceLabel" to "Devreden (Ay Başı)",
        "debtLabel" to "Borç",
        "receivableLabel" to "Alacak",
        "closedLabel" to "Kapalı",
        "addCustomer" to "Müşteri Ekle",
        "addSupplier" to "Tedarikçi Ekle",
        "debtsEmpty" to "Henüz hesap yok.\nTedarikçi (malzeme aldıklarınız) veya müşteri " +
            "(malzeme sattıklarınız) ekleyin; alım-satım ve ödemeleri takip edin.",
        "customer" to "Müşteri",
        "supplier" to "Tedarikçi",
        "newCustomer" to "Yeni Müşteri",
        "newSupplier" to "Yeni Tedarikçi",
        "customerAccountSubtitle" to "Malzeme sattığınız cari hesap",
        "supplierAccountSubtitle" to "Malzeme aldığınız cari hesap",
        "customerNameLabel" to "Müşteri Adı",
        "firmNameLabel" to "Firma Adı",
        "addCraftsman" to "Usta Ekle",
        "craftsmenEmpty" to "Henüz usta kaydı yok.\nDaire karşılığı çalışan ustaları ekleyin; " +
            "yapılan işi, verilen daireleri ve hesabı buradan takip edin.",
        "craftsmanOwed" to "Usta alacaklı",
        "craftsmanOwes" to "Usta borçlu",
        "balanced" to "Denk",
        "workDone" to "Yapılan iş",
        "unitsGivenCount" to "{count} daire verildi",
        "craftsman" to "Usta",
        "invoiceProgress" to "Fatura: {invoiced} / {required} kesildi",
        "units" to "daire",
        "newCraftsman" to "Yeni Usta",
        "newCraftsmanIntro" to "Daire karşılığı çalışan usta. Anlaşılan iş miktarı ve birim bedel, " +
            "hak edişin hesabında kullanılır.",
        "craftsmanNameLabel" to "Ad (örn. Elektrikçi Ahmet)",
        "tradeLabel" to "İş Kolu (Elektrik, Sıva…)",
        "agreedWorkSection" to "Anlaşılan İş (daire tipine göre)",
        "countLabel" to "Adet",
        "pricePerUnitLabel" to "Daire Başı ₺",
        "requiredInvoiceLabel" to "Kesilecek Fatura (₺, opsiyonel)",
        "requiredInvoiceHint" to "Müteahhidin bu ustadan istediği toplam fatura tutarı. " +
            "Kesilen faturalar usta sayfasından \"Hareket → Fatura\" ile girilir.",
        "pdfMonthlyReport" to "Aylık Rapor",
        "pdfMonthlyReportSubtitle" to "Aylık İşlem Raporu",
        "pdfTransactionCount" to "{count} işlem",
        "pdfCarriedBalance" to "Devreden Bakiye",
        "pdfTotalIncome" to "Toplam Gelir",
        "pdfTotalExpense" to "Toplam Gider",
        "pdfMonthlyNet" to "Aylık Net",
        "pdfClosingBalance" to "Ay Sonu Bakiyesi",
        "pdfProjectSummary" to "Proje Özeti",
        "pdfGeneralInfo" to "Genel Bilgi",
        "pdfStartDate" to "Başlangıç",
        "pdfEstimatedEnd" to "Tahmini Bitiş",
        "pdfBuilding" to "Bina",
        "pdfBuildingTemplate" to "{floors} kat • kat başına {perFloor} daire",
        "pdfConstructionProgress" to "İnşaat İlerlemesi",
        "pdfCompletedStages" to "Tamamlanan Aşamalar",
        "pdfNote" to "Not",
        "pdfUnitStatus" to "Daire Durumu",
        "pdfTotalUnits" to "Toplam Daire",
        "pdfSold" to "Satıldı",
        "pdfReserved" to "Rezerve",
        "pdfAvailable" to "Satılık",
        "pdfSalesTotal" to "Satış Toplamı",
        "pdfSoldUnits" to "Satılan Daireler",
        "pdfUnit" to "Daire",
        "pdfBuyer" to "Alıcı",
        "pdfPrice" to "Bedel",
        "pdfPaid" to "Ödenen",
        "pdfRemaining" to "Kalan",
        "pdfBarterSuffix" to "iş karşılığı",
        "pdfProjectTransactions" to "Projeye Bağlı İşlemler",
        "pdfNet" to "Net",
        "pdfCraftsmanStatement" to "Usta Hesap Özeti",
        "pdfCraftsmenOverview" to "Ustalar — İş Karşılığı Hesap Özeti",
        "pdfCraftsmanCount" to "{count} usta",
        "pdfTrade" to "İş Kolu",
        "pdfDoneAgreed" to "Yapılan / Anlaşılan",
        "pdfCurrentStatus" to "Güncel Durum",
        "pdfWhenFinished" to "İş Bitince",
        "pdfRemainingInvoice" to "Kalan Fatura",
        "pdfAgreedWork" to "Anlaşılan İş",
        "pdfUnitType" to "Daire Tipi",
        "pdfAgreed" to "Anlaşılan",
        "pdfDone" to "Yapılan",
        "pdfUnitPrice" to "Birim Bedel",
        "pdfAgreedValue" to "Anlaşma Tutarı",
        "pdfEarned" to "Hak Ediş",
        "pdfGivenUnits" to "Verilen Daireler (iş karşılığı)",
        "pdfInvoiceStatus" to "Fatura Durumu",
        "pdfRequiredInvoice" to "Kesilmesi gereken fatura",
        "pdfIssuedInvoice" to "Kesilen fatura",
        "pdfRemainingInvoiceLong" to "Kalan kesilmesi gereken",
        "pdfAccountEntries" to "Hesap Hareketleri",
        "pdfType" to "Tür",
        "pdfExtraWork" to "Ekstra iş/malzeme",
        "pdfCashPayment" to "Nakit ödeme",
        "pdfIssuedInvoiceEntry" to "Kesilen fatura",
        "pdfEarnedFromWork" to "Hak ediş (yapılan iş)",
        "pdfGivenUnitValue" to "Verilen daire bedeli",
        "pdfCashPaidTotal" to "Nakit ödenen",
        "pdfCraftsmanOwedText" to "Usta {amount} alacaklı",
        "pdfCraftsmanOwesText" to "Usta {amount} borçlu",
        "pdfAccountBalanced" to "Hesap denk",
        "pdfStatement" to "Cari Hesap Ekstresi",
        "pdfBalance" to "Bakiye",
        "pdfPurchase" to "Borç",
        "pdfPayment" to "Ödeme",
        "pdfSale" to "Satış",
        "pdfCollection" to "Tahsilat",
        "pdfTotalPurchases" to "Toplam Alım",
        "pdfTotalPayments" to "Toplam Ödeme",
        "pdfTotalSales" to "Toplam Satış",
        "pdfTotalCollections" to "Toplam Tahsilat",
        "pdfCurrentReceivable" to "Güncel Alacak",
        "pdfCurrentDebt" to "Güncel Borç",
        "dateLabel" to "Tarih",
        "amountFieldLabel" to "Tutar (₺)",
        "enterValidAmount" to "Geçerli bir tutar girin.",
        "completed" to "Tamamlandı",
        "deleteCraftsmanAction" to "Ustayı sil",
        "updateWork" to "İş Güncelle",
        "giveUnitAction" to "Daire Ver",
        "entryAction" to "Hareket",
        "givenUnitsSection" to "Verilen Daireler",
        "accountEntriesSection" to "Hesap Hareketleri",
        "noEntriesYet" to "Henüz hareket yok.\n\"Hareket\" ile ekstra iş/malzeme veya nakit ödeme ekleyin.",
        "takeBackUnitTitle" to "Daireyi Geri Al",
        "takeBackUnitMessage" to "{unit} takastan çıkarılıp tekrar satılık yapılsın mı?",
        "takeBack" to "Geri Al",
        "deleteEntryTitle" to "Hareketi Sil",
        "deleteEntryMessage" to "{desc} ({amount}) silinsin mi?",
        "deleteCraftsmanTitle" to "Ustayı Sil",
        "deleteCraftsmanMessage" to "\"{name}\" ve tüm hesap hareketleri silinecek. Verilen daireler satılmış olarak kalır. Emin misin?",
        "craftsmanOwedTitle" to "Usta Alacaklı",
        "craftsmanOwesTitle" to "Usta Borçlu",
        "accountBalancedTitle" to "Hesap Denk",
        "agreementTotal" to "Anlaşma toplamı: {amount}",
        "doneRemaining" to "Yapılan: {done} • Kalan: {remaining} {units}",
        "earnedFromWorkLine" to "Hak Ediş (yapılan iş)",
        "extraWorkLine" to "Ekstra iş / malzeme",
        "givenUnitValueLine" to "Verilen daire bedeli",
        "cashPaidLine" to "Nakit ödenen",
        "whenFinishedLine" to "İş bitince",
        "whenFinishedOwed" to "Usta {amount} alacaklı olacak",
        "whenFinishedOwes" to "Usta {amount} borçlu olacak",
        "whenFinishedBalanced" to "Hesap denk kapanacak",
        "givenAsBarter" to "İş karşılığı verildi",
        "invoiceCardTitle" to "Kesilecek Fatura",
        "invoiceRemainingShort" to "Kalan {amount}",
        "invoiceIssuedOf" to "Kesilen: {invoiced} / {required}",
        "invoiceCardHint" to "Müteahhidin istediği fatura tutarını girmek için dokun. Kesilen faturalar \"Hareket → Fatura\" ile eklenir.",
        "invoiceDialogTitle" to "Kesilecek Fatura Tutarı",
        "invoiceDialogHint" to "Müteahhidin bu ustadan istediği toplam fatura tutarı. Sıfır girersen fatura takibi kapanır.",
        "updateWorkTitle" to "Yapılan İşi Güncelle",
        "updateWorkHint" to "Daire tipine göre tamamlanan sayıları gir. Yanlış girdiysen geri çekebilirsin.",
        "workTypeAgreedLabel" to "{type} — anlaşılan {count}",
        "entryTypeCash" to "Nakit",
        "entryTypeExtra" to "Ekstra İş",
        "entryTypeInvoice" to "Fatura",
        "entryCashTitle" to "Nakit Ödeme",
        "entryExtraTitle" to "Ekstra İş / Malzeme",
        "entryInvoiceTitle" to "Kesilen Fatura",
        "descCashHint" to "Açıklama (örn. avans)",
        "descExtraHint" to "Açıklama (örn. bodrum elektriği, kablo)",
        "descInvoiceHint" to "Açıklama (örn. fatura no)",
        "hintCashPayment" to "Ustanın alacağından düşülür. Kasaya otomatik gider yazılmaz — istersen İşlemler'den ayrıca girin.",
        "hintExtraWork" to "Ustanın alacağına eklenir (anlaşma dışı iş veya verdiği malzeme).",
        "hintInvoice" to "Kesilen fatura toplamına eklenir; ustanın bakiyesini etkilemez.",
        "giveUnitTitle" to "İş Karşılığı Daire Ver",
        "giveUnitHint" to "Daire satıldı olur ama takas olduğu için kasaya gelir yazılmaz; bedeli ustanın hesabından düşülür.",
        "unitValueLabel" to "Daire Bedeli (₺)",
        "give" to "Ver",
        "selectUnitError" to "Daire seçin.",
        "enterUnitValueError" to "Daire bedelini girin.",
        "unitLabel" to "Daire",
        "importing" to "İçe aktarılıyor…",
        "importDoneTitle" to "İçe Aktarma Tamamlandı",
        "importDoneMessage" to "{count} işlem eklendi.",
        "importFailedTitle" to "İçe Aktarılamadı",
        "importPreviewTitle" to "İçe Aktarma Önizleme",
        "importIncomeRows" to "Gelir işlemi",
        "importExpenseRows" to "Gider işlemi",
        "importHouseRows" to "Ev gideri (gider içinde)",
        "importSkippedSales" to "Daire satışı (atlanır)",
        "importRowCount" to "{count} satır",
        "importTargetProject" to "Tüm satırlar \"{project}\" projesine yazılacak.",
        "importUnknownProjects" to "Eşleşmeyen projeler (işlemler projesiz aktarılır): ",
        "importSkippedRows" to "Atlanan satırlar ({count}):",
        "importAction" to "İçe Aktar",
        "importNoRows" to "Dosyada içe aktarılacak satır bulunamadı. Sütun sırası: Tarih, Tür (GELİR/GİDER/EV GİDER), Kategori, Açıklama, Proje, Tutar.",
        "importSalesSkippedNote" to "Daire satış satırları içe aktarılmaz ({count} satır).",
        "importFailedMessage" to "İçe aktarma başarısız: {error}",
        "unknownError" to "bilinmeyen hata",
        "projectNameLabel" to "Proje Adı",
        "locationLabel" to "Konum",
        "startLabel" to "Başlangıç",
        "estimatedEndLabel" to "Tahmini Bitiş",
        "floorCountLabel" to "Kat Sayısı",
        "unitsPerFloorLabel" to "Kat Başına Daire",
        "coverColorLabel" to "Kart Rengi",
        "createProject" to "Projeyi Oluştur",
        "errorProjectName" to "Proje adı girin.",
        "errorFloors" to "Kat sayısı 1-60 arasında olmalı.",
        "errorUnitsPerFloor" to "Kat başına daire 1-12 arasında olmalı.",
        "newTransaction" to "Yeni İşlem",
        "editTransaction" to "İşlemi Düzenle",
        "incomeType" to "Gelir Türü",
        "expenseCategory" to "Gider Kategorisi",
        "descriptionOptional" to "Açıklama (opsiyonel)",
        "soldUnitLabel" to "Satılan Daire",
        "errorSelectIncomeType" to "Gelir türü seçin.",
        "errorSelectExpenseCategory" to "Gider kategorisi seçin.",
        "errorSelectProjectForSale" to "Daire satışı için proje seçin.",
        "errorSelectSoldUnit" to "Satılan daireyi seçin.",
        "errorEnterDescription" to "Açıklama girin.",
        "noUnitsAvailable" to "Bu projede satışa uygun daire kalmadı.",
        "noUnitsDefined" to "Bu proje için daire tanımlanmamış.",
        "saleMarksUnit" to "Kaydedilince seçilen daire projede satıldı olarak işaretlenir.",
        "deleteProjectAction" to "Projeyi sil",
        "buildingLabel" to "Bina",
        "buildingValue" to "{floors} kat • kat başına {perFloor} daire",
        "constructionStatus" to "İnşaat Durumu",
        "progressLabel" to "İlerleme",
        "showStages" to "Aşamaları göster",
        "completedCheck" to "Tamamlandı ✓",
        "completedParty" to "Tamamlandı 🎉",
        "buyersSection" to "Alıcılar",
        "projectTransactionsSection" to "Proje İşlemleri",
        "noProjectTransactions" to "Bu projeye bağlı işlem yok.",
        "deleteProjectTitle" to "Projeyi Sil",
        "deleteProjectMessage" to "\"{name}\" ve tüm daire kayıtları kalıcı olarak silinecek. Aylık gelir/gider kayıtları muhasebe geçmişinde kalır. Emin misin?",
        "barterUnitSubtitle" to "Kat {floor} • İş Karşılığı (Takas)",
        "floorShort" to "Kat {floor}",
        "statusSold" to "Satıldı",
        "statusReserved" to "Rezerve",
        "statusAvailable" to "Satılık",
        "barterShort" to "İş Karşılığı",
        "salePriceLabel" to "Satış Fiyatı (₺)",
        "saleDateLabel" to "Satış Tarihi",
        "buyerNameLabel" to "Alıcı Adı",
        "buyerPhoneLabel" to "Alıcı Telefonu (opsiyonel)",
        "paymentsReceived" to "Alınan Ödemeler",
        "addPayment" to "+ Ödeme Ekle",
        "deletePayment" to "Ödemeyi sil",
        "remainingDebt" to "Kalan Borç",
        "fullyPaid" to "Tamamı ödendi ✓",
        "paidAmount" to "Ödenen {amount}",
        "errorSalePrice" to "Satış fiyatı girin.",
        "noBuyerGiven" to "Alıcı belirtilmedi",
        "barterInfo" to "{unit} iş karşılığı verilmiştir. Hesap detayı (hak ediş, ödemeler) Ustalar sayfasındadır.",
        "saleSummary" to "{unit} • Satış {amount}",
        "deleteAccountAction" to "Hesabı sil",
        "printPdf" to "PDF olarak yazdır",
        "materialPurchase" to "Malzeme Alımı",
        "materialSale" to "Malzeme Satımı",
        "paymentOrCarry" to "Ödeme / Devir",
        "collectionOrCarry" to "Tahsilat / Devir",
        "noEntriesSupplier" to "Henüz hareket yok.\nMalzeme alımlarını, ödemeleri ve varsa devreden borcu buradan kaydedin.",
        "noEntriesCustomer" to "Henüz hareket yok.\nMalzeme satışlarını, tahsilatları ve varsa devreden alacağı buradan kaydedin.",
        "purchasePrefix" to "Alım",
        "salePrefix" to "Satış",
        "deleteRecordTitle" to "Kaydı Sil",
        "thisRecord" to "Bu kayıt",
        "deleteRecordMessage" to "{desc} ({amount}) silinsin mi?",
        "deleteCustomerTitle" to "Müşteriyi Sil",
        "deleteSupplierTitle" to "Tedarikçiyi Sil",
        "deleteAccountMessage" to "\"{name}\" ve tüm hesap hareketleri kalıcı olarak silinecek. Emin misin?",
        "materialSaleEntry" to "Malzeme satışı",
        "materialPurchaseEntry" to "Malzeme alımı",
        "makePayment" to "Ödeme Yap",
        "addCarryReceivable" to "Devir Alacağı Ekle",
        "addCarryDebt" to "Devir Borcu Ekle",
        "carryReceivable" to "Devir Alacağı",
        "carryDebt" to "Devir Borcu",
        "descPaymentHint" to "Açıklama (nakit, kart, çek…)",
        "descCarryHint" to "Açıklama (örn. eski hesaptan devir)",
        "hintCarryReceivable" to "Devir alacağı bakiyeye eklenir; üzerine yeni satışlar işlenebilir.",
        "hintCarryDebt" to "Devir borcu bakiyeye eklenir; üzerine yeni malzeme alımları işlenebilir.",
        "editPurchase" to "Alımı Düzenle",
        "editSale" to "Satışı Düzenle",
        "itemNameLabel" to "Açıklama / İsim",
        "deleteRow" to "Satırı sil",
        "rowTotal" to "Satır toplamı: {amount}",
        "errorAtLeastOneItem" to "En az bir malzeme satırı girin.",
        "errorIncompleteRow" to "Eksik satır var: malzeme adı, miktar ve birim fiyat zorunlu.",
        "errorEnterReceiver" to "Teslim alan kişiyi girin.",
        "kurusLabel" to ",kuruş",
        "blockWord" to "Blok",
        "buildingStatus" to "Bina Durumu",
        "blockSummary" to "{sold}/{total} satıldı",
        "pdfBlock" to "Blok",
        "blocksSection" to "Bloklar",
        "blocksHint" to "Her blok kendi kat ve daire sayısına sahip olabilir. Tek blok yeterliyse olduğu gibi bırakın.",
        "addBlock" to "+ Blok Ekle",
        "removeBlock" to "Bloğu sil",
        "blockNameLabel" to "Blok Adı",
        "errorBlockLayout" to "Her blok için kat sayısı (1-60) ve kat başına daire (1-12) girin.",
        "blockLayoutSummary" to "{floors} kat × {perFloor} daire",
        "pdfBlocks" to "Bloklar",
        "addToDailyLedger" to "Günlük işlemlere ekle",
        "addToDailyLedgerHintOn" to "İşlem aylık kasa raporlarında görünür.",
        "addToDailyLedgerHintOff" to "İşlem yalnızca projeye yazılır; aylık kasada (Panel, İşlemler, Rapor) görünmez.",
        "errorProjectRequiredOffLedger" to "Kasaya işlenmeyen kayıt için proje seçin.",
        "projectOnlyBadge" to "Sadece proje",
    ),
)
